import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import useActiveProduct from '../../../hooks/product/useActiveProduct';
import Product from '../../../models/Product';
import { modelOf } from '../../../prop-types';
import LocationContext from '../../../services/LocationContext';
import ProductCollectionProductPicker from '../ProductCollectionProductPicker';
import ProductMultiProductPicker from '../ProductMultiProductPicker';

const ProductPickers = ({
  product,
  activeProductId,
  onProductChange,
  checkoutCart,
  activeCollectionElementIds,
  locationContext,
}) => {
  const { setActiveProductId } = useActiveProduct({
    productPage: false,
    checkoutPage: true,
  });

  const handleProductChange = (productId, queryParams) => {
    const activeProductId = setActiveProductId({
      activeProductId: productId,
      queryParams,
    });

    onProductChange(activeProductId);
  };

  return (
    <>
      {product.isCollection && (
        <ProductCollectionProductPicker
          product={product}
          productImages={product.images}
          activeProductId={activeProductId}
          productCollection={product.collection}
          onProductChange={handleProductChange}
          columnId={activeCollectionElementIds.columnId}
          rowId={activeCollectionElementIds.rowId}
        />
      )}
      {product.isMulti && (
        <ProductMultiProductPicker
          key={product.id}
          activeProductId={activeProductId}
          product={product}
          productImages={product.images}
          onProductChange={(productId) => onProductChange(productId)}
          path={`${locationContext.protocol}//${locationContext.host}`}
          checkoutCart={checkoutCart}
        />
      )}
    </>
  );
};

ProductPickers.propTypes = {
  product: modelOf(Product).isRequired,
  locationContext: PropTypes.instanceOf(LocationContext).isRequired,
  activeCollectionElementIds: PropTypes.shape({
    columnId: PropTypes.number,
    rowId: PropTypes.number,
  }).isRequired,
  activeProductId: PropTypes.string,
  checkoutCart: PropTypes.bool,
  onProductChange: PropTypes.func,
};

export default inject('locationContext')(observer(ProductPickers));
